"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVCUser = void 0;
// import packageJson from '../package.json'
var uuid_1 = require("uuid");
var DVCUser = /** @class */ (function () {
    function DVCUser(user) {
        if (!user.user_id && !user.isAnonymous) {
            throw new Error('Must have a user_id, or have "isAnonymous" set on the user');
        }
        this.user_id = user.isAnonymous && !user.user_id ? (0, uuid_1.v4)() : user.user_id;
        this.isAnonymous = user.user_id ? false : user.isAnonymous;
        this.email = user.email;
        this.name = user.name;
        this.language = user.language;
        this.country = user.country;
        this.appVersion = user.appVersion;
        this.appBuild = user.appBuild;
        this.customData = user.customData;
        this.privateCustomData = user.privateCustomData;
        this.lastSeenDate = new Date();
        /**
         * Read only properties initialized once
         */
        this.createdDate = new Date();
        this.platform = 'web';
        this.platformVersion = '1.0.9';
        this.deviceModel = window.navigator.userAgent;
        this.sdkType = 'client';
        this.sdkVersion = '1.0.9';
    }
    DVCUser.prototype.updateUser = function (user) {
        if (this.user_id !== user.user_id) {
            throw new Error('Cannot update a user with a different user_id');
        }
        this.email = user.email;
        this.name = user.name;
        this.language = user.language;
        this.country = user.country;
        this.appVersion = user.appVersion;
        this.appBuild = user.appBuild;
        this.customData = user.customData;
        this.privateCustomData = user.privateCustomData;
        this.lastSeenDate = new Date();
        return this;
    };
    return DVCUser;
}());
exports.DVCUser = DVCUser;
//# sourceMappingURL=User.js.map